<template>
  <div style="background:#fff; margin: 16px 16px 0 16px; padding:16px 0;">
    <div v-html="html"></div>
  </div>
</template>

<script>
export default {
  name: "Exp500",
  data() {
    return {
      html: ''
    }
  },
  created() {
    this.html = this.$route.params.info;
  }
}
</script>

<style scoped>

</style>